import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ANIMATION, ANIMATIONS} from '../notification/models/animations';

@Component({
	selector: 'cv-notification-update',
	templateUrl: './notification-update.component.html',
	animations: [ANIMATION],
	styleUrls: ['./notification-update.component.scss']
})
export class NotificationUpdateComponent implements OnInit {
	@Output() update: EventEmitter<any> = new EventEmitter<any>();
	@Input() title: string;
	@Input() message: string;
	alertClass: string;
	animationState: ANIMATIONS;

	/**
	 * On init calculate variable values.
	 */
	ngOnInit(): void {
		this.alertClass = `alert-success`;
		setTimeout(() => this.showNotification(), 100);
	}

	/**
	 * Displays the notification and emits the event.
	 */
	showNotification(): void {
		this.animationState = ANIMATIONS.IN;
	}

	/**
	 * Sent the instructions to Update to the User
	 */
	onUpdate(): void {
		this.update.emit();
	}
}
